/**
 * Semantic connector profile registry. Profiles are code (PR-reviewed
 * declarations); registry closure is enforced by
 * semanticConnectorRegistry.test.ts (pattern: flagModuleRegistry.test.ts).
 */

import type { ConnectorProfile } from '../profileTypes';
import type { RelationshipCueRule, TypeMapRule } from '../../fieldMappingRegistry';
import { MIRO_PROFILE, MIRO_DEFAULT_RELATIONSHIP_MAP, MIRO_DEFAULT_TYPE_MAP } from './miro';
import { NOTION_PROFILE, NOTION_DEFAULT_RELATIONSHIP_MAP, NOTION_DEFAULT_TYPE_MAP } from './notion';
import { LINEAR_PROFILE, LINEAR_DEFAULT_RELATIONSHIP_MAP, LINEAR_DEFAULT_TYPE_MAP } from './linear';
import { JIRA_PROFILE, JIRA_DEFAULT_RELATIONSHIP_MAP, JIRA_DEFAULT_TYPE_MAP } from './jira';
import { PERPLEXITY_PROFILE } from './perplexity';

export const CONNECTOR_PROFILES: ConnectorProfile[] = [
  MIRO_PROFILE,
  NOTION_PROFILE,
  LINEAR_PROFILE,
  JIRA_PROFILE,
  // acquisition:'ambient' — contributes watch entities to Beacon, not items.
  PERPLEXITY_PROFILE,
];

export function getConnectorProfile(connectorType: string): ConnectorProfile | null {
  return CONNECTOR_PROFILES.find(p => p.connectorType === connectorType) ?? null;
}

/** Profile-shipped intelligent defaults; workspace v3 rules override these. */
export function getDefaultRelationshipMap(connectorType: string): RelationshipCueRule[] {
  if (connectorType === 'miro') return MIRO_DEFAULT_RELATIONSHIP_MAP;
  if (connectorType === 'notion') return NOTION_DEFAULT_RELATIONSHIP_MAP;
  if (connectorType === 'linear') return LINEAR_DEFAULT_RELATIONSHIP_MAP;
  if (connectorType === 'jira') return JIRA_DEFAULT_RELATIONSHIP_MAP;
  return [];
}

export function getDefaultTypeMap(connectorType: string): TypeMapRule[] {
  if (connectorType === 'miro') return MIRO_DEFAULT_TYPE_MAP;
  if (connectorType === 'notion') return NOTION_DEFAULT_TYPE_MAP;
  if (connectorType === 'linear') return LINEAR_DEFAULT_TYPE_MAP;
  if (connectorType === 'jira') return JIRA_DEFAULT_TYPE_MAP;
  return [];
}
